// hooks/usePagination.js
import { useEffect, useState } from "react";

/**
 * usePagination
 * @param {Array}  items    - full filtered array
 * @param {number} perPage  - rows per page (default 8)
 * @returns {{ paged, page, setPage, total, count }}
 */
export function usePagination(items, perPage = 8) {
  const [page, setPage] = useState(1);

  const total    = Math.max(1, Math.ceil(items.length / perPage));
  const safePage = Math.min(page, total);
  const paged    = items.slice((safePage - 1) * perPage, safePage * perPage);

  // reset to last valid page when items shrink
  useEffect(() => {
    if (page > total) setPage(total);
  }, [items.length, total]);

  return { paged, page: safePage, setPage, total, count: items.length };
}
